import Rot13 from '@hogashi/rot13';
import VideoListItem from "./modules/VideoListItem";


import {toggleClass,hasClass, VimeoPlayer} from '@cognetif/js-toolkit';


export default class App {
    constructor() {
        this.app = document.getElementById('app');
    }

    run() {
        this.maskedEmail();
        this.infoSlide();
        this.videoListItems();


    }

    videoListItems() {

        if (document.getElementsByClassName('video-player').length > 0) {
            const videoPlayer = new VimeoPlayer(document.getElementsByClassName('video-player')[0]);
            videoPlayer.setControlColor('8F8178');

            ((videoListItems) => {
                Array.from(videoListItems).forEach((videoListItem) => {
                    new VideoListItem(videoListItem, videoPlayer);
                });
            })(document.getElementsByClassName('video-list__item'));
        }
    }

    infoSlide() {
        ((infoSlides) => {
            Array.from(infoSlides).forEach((infoSlide) => {

                infoSlide.addEventListener('click', (e) => {
                    e.preventDefault();
                    let target = document.getElementById(infoSlide.href.split('#')[1]);
                    let closer = target.querySelector('.info-slide-container__closer');

                    this.closeOpenInfoSlides(target, infoSlide);
                    toggleClass(this.app, 'bg-blur');
                    toggleClass(infoSlide, 'slide-open');
                    toggleClass(target, 'slide-open');

                    closer.addEventListener('click', (e) => {
                        toggleClass(this.app, 'bg-blur');
                        toggleClass(infoSlide, 'slide-open');
                        toggleClass(target, 'slide-open');

                    });
                });


            });
        })(document.getElementsByClassName('info-slide'));


    }

    closeOpenInfoSlides(target, activeSlide) {
        ((infoSlides) => {
                Array.from(infoSlides).forEach((infoSlide) => {
                    if (infoSlide !== target && infoSlide !== activeSlide) {
                        toggleClass(infoSlide, 'slide-open');
                    }
                });

        })(document.getElementsByClassName('slide-open'));
    }

    maskedEmail() {
        ((elems) => {
            const rot13 = new Rot13();
            Array.from(elems).forEach((elem) => {
                let email = elem.getAttribute('href');
                email = email.replace('mailto:', '');
                email = rot13.decrypt(email);
                elem.setAttribute('href', 'mailto:' + email);
                elem.innerHTML = email;
            });
        })(document.getElementsByClassName('masked-email'));
    }


}